import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const urlParams = new URLSearchParams(window.location.search)
const externalId = urlParams.get('externalId')
const defaultExternalId = (externalId ? parseInt(externalId, 10) : 0)
// to handle state
const state = {
  selectedTemplate: null,
  activeView: 'table',
  activeType: 'saved', // saved || prebuilt
  customLinksHost: '',
  templates: {
    result: [],
    count: 0
  },
  globalTemplates: {
    result: [],
    count: 0
  },
  template: {
    summary: {},
    campaigns: [],
    history: [],
    basicValidation: []
  },
  globalCompanyPermission: false,
  globalUserPermission: false,
  globalPaging: {
    page: 1,
    pageCount: 4,
    pageSizes: ['12', '24', '48', '90'],
    pageSize: 12,
    totalRecords: 0,
    order: {
      column: 'updateDate',
      direction: 'descending'
    },
    tags: [],
    searchBox: '',
    search: ''
  },
  paging: {
    page: 1,
    pageCount: 4,
    pageSizes: ['12', '24', '48', '90'],
    pageSize: 12,
    totalRecords: 0,
    order: {
      column: 'updateDate',
      direction: 'descending'
    },
    tags: [],
    searchBox: '',
    search: ''
  },
  externalId: defaultExternalId,
  accountId: 0,
  eGalleryUid: 0,
  account: null,
  allAccounts: [],
  allowedAccounts: [],
  availableAccounts: [],
  gridSelectedTemplate: {},
  templateSelectedForPreview: null,
  templatePreviewContent: null,
  validationTemplateId: '',
  templateOnEdition: null,
  loadingStatus: {},
  locale: '',
  dateFormat: null,
  timeFormat: null,
  userEmail: '',
  userAccessControl: {},
  einsightUri: '',
  environmentName: 'eInsight QA Application',
  appConfig: {},
  grapesJSConfig: {
    plugins: [
      {
        name: 'gjs-cendyneditor-einsight',
        opt: {
          juiceCssFile: 'css/canvas-items.css',
          modalLabelExport: '',
          codeViewerTheme: '',
          cellStyle: {
            'font-size': '12px',
            'font-weight': 300,
            'vertical-align': 'top',
            color: 'rgb(111, 119, 125)',
            margin: 0,
            padding: 0
          },
          icons: {
            'menu.normalIcon.path': '/images/icon-d.svg',
            'menu.activeIcon.path': '/images/icon-b.svg',
            'menu.disabledIcon.path': '/images/icon-a.svg',
            'menu.hoverIcon.path': '/images/icon-c.svg',
            'submenu.normalIcon.path': '/images/icon-d.svg',
            'submenu.activeIcon.path': '/images/icon-c.svg'
          }
        }
      },
      {
        name: 'grapesjs-tui-image-editor',
        opt: ''
      }
    ],
    customizationConfig: null
  },
  grapesJSInstance: null,
  editorsTypes: [],
  tags: [],
  users: [],
  gridStateChangeData: null,
  dynamicContent: {
    isModalOpen: false,
    selectedTab: 1,
    tagsSections: [],
    personalizationTags: [],
    addOns: [],
    customLinks: [],
    globalLinks: [],
    globalLinkOnEdition: null,
    systemLinks: [],
    allLinks: []
  },
  emailTesting: {
    canModifyTestList: false,
    canModifyGlobalList: false,
    emailList: [],
    groups: {},
    sendTestModalRef: null,
    sendTestModalIsOpen: false,
    hasDialogClose: false,
    manageModalRef: null,
    emailTestingOnEdition: null,
    editingModalIsOpen: false
  },
  isSearchingTemplate: null,
  isCreatingCampaign: null,
  accessSettings: {
    canCreateTemplate: false
  },
  savedGridEditorFilter: [
    'Studio Editor',
    'Classic Drag & Drop',
    'Custom Code'
  ],
  prebuiltGridEditorFilter: [
    'Studio Editor',
    'Classic Drag & Drop',
    'Custom Code'
  ],
  studioEditorCreatePermission: false,
  dragAndDropCreatePermission: false,
  customCodeCreatePermission: false
}

export const templateBuilder = {
  state,
  getters,
  actions,
  mutations
}
